/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Chat, VideoChat } from "../../../Constant";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import axios from "axios";
import { ChatMemberApi } from "../../../api";
import { useEffect } from "react";
import { fetchChatMemberAsync, setAllMembers } from "../../../Redux-Toolkit/Reducers/ChatSlice";
import ChatStatus from "../Common/ChatStatus";
import ChatMenu from "../Common/ChatMenu";
import VideoCallPage from "./VideoCallPage";
import { toast } from "react-toastify";

const VideoChatContainer = () => {
  const dispatch = useAppDispatch();
  const getChatMembersData = async () => {
    try {
      await axios.get(ChatMemberApi).then((resp) => {
        dispatch(setAllMembers(resp.data));
        dispatch(fetchChatMemberAsync());
      });
    } catch (error) {
      toast.error("error" + error);
    }
  };
  useEffect(() => {
    getChatMembersData();
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={VideoChat} parent={Chat} title={VideoChat} />
      <Container fluid>
        <Row>
          <Col sm="12" className="call-chat-sidebar">
            <Card>
              <CardBody className="chat-body">
                <ChatStatus />
              </CardBody>
            </Card>
          </Col>
          <Col className="call-chat-body">
            <Card>
              <CardBody className="p-0">
                <Row className="chat-box">
                  <VideoCallPage />
                  <ChatMenu />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default VideoChatContainer;
